import {clsx, type ClassValue} from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

const twMerge = extendTailwindMerge<'choice-selected'>({
  extend: {
    classGroups: {
      'font-size': [
        'text-display-xl',
        'text-display-lg',
        'text-display-md',
        'text-display-sm',
        'text-display-xs',
        'text-display-2xs',
        'text-caption',
        'text-calendar-weekday'
      ],
      // named shadow values aren't auto-detected without a `theme` config — list them so cn() dedupes
      shadow: [
        'shadow-xs',
        'shadow-sm',
        'shadow-md',
        'shadow-skeumorphic',
        'shadow-xs-skeumorphic',
        'shadow-fab',
        'shadow-primary'
      ],
      px: ['px-page'],
      'choice-selected': ['choice-selected']
    },
    conflictingClassGroups: {
      'choice-selected': ['bg-color', 'border-color', 'ring-color', 'ring-w']
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Flattens an optional grouped/ungrouped option list into one array — shared by FieldSelect and FieldCombobox. */
export function flattenOptionGroups<TOption>(
  groups: {options: TOption[]}[] | undefined,
  options: TOption[] | undefined
): TOption[] {
  return groups ? groups.flatMap(g => g.options) : (options ?? []);
}
